/* eslint-disable */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'underscore'
import MenuListComponent from './listComponent'
import './menu.css'
import CommonService from '../../../services/commonService'
import { withTranslation } from 'react-i18next'
import i18n from '../../../i18n'
import dataConstant from '../../../constants/dataConstants'

let menuContentArray = []
let menuList = []

class MenuLeft extends Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
    this.OnMenuLinkClick = this.OnMenuLinkClick.bind(this)
  }

  componentDidMount() {
    const urlReferenceLink = window.location.pathname
    let menuIDforRefreshPage = _.find(menuList, function findMenu(obj) {
      return obj.menuLink === urlReferenceLink
    })

    if (menuIDforRefreshPage === dataConstant.Undefined && menuList.length > 0) {
      const subMenu =
        urlReferenceLink.split('/').length === 3 || urlReferenceLink.split('/').length === 2
          ? urlReferenceLink.split('/')[1]
          : ''
      var subMenuList = _.filter(menuList, menu => menu.subMenuLink !== null)
      var menuWithAllSubMenu = _.flatten(
        _.map(subMenuList, item => {
          const subMenuLinks = item.subMenuLink.split(',')
          return _.map(subMenuLinks, menu => {
            return { menuId: item.menuId, menuLink: item.menuLink, subMenuLink: menu }
          })
        }),
      )
      menuIDforRefreshPage = _.find(menuWithAllSubMenu, function findMenu(obj) {
        return obj.subMenuLink === `/${subMenu}`
      })
    }
    if (typeof menuIDforRefreshPage !== dataConstant.APIResponseStatus.Undefined) {
      if (menuIDforRefreshPage.ParentID === 0) {
        this.OnParentMenuClick(menuIDforRefreshPage.menuId)
      } else {
        this.OnMenuLinkClick(menuIDforRefreshPage.menuId)
      }
    }

    //Fix Menu scroll issue after login
    if (document.querySelector('.menu-categories') !== null) {
      const ps = new PerfectScrollbar('.menu-categories', {
        wheelSpeed: 0.5,
        swipeEasing: !0,
        minScrollbarLength: 40,
        maxScrollbarLength: 300,
        suppressScrollX: true,
      })
    }
  }

  OnMenuClickWithRemoveTimeOut = data => {
    let timeOutIds = window.setTimeout(function() {}, 0)
    while (timeOutIds--) {
      window.clearTimeout(timeOutIds)
    }
    this.OnMenuLinkClick(data)
  }

  OnMenuLinkClick = data => {
    for (let i = 0; i < menuList.length; i += 1) {
      const htmlElement = document.getElementById(menuList[i].menuId)
      if (htmlElement !== null) {
        htmlElement.setAttribute('data-active', 'false')
      }
    }
    const liID = `li_${data}`
    for (let i = 0; i < menuList.length; i += 1) {
      const htmlElement = document.getElementById(`li_${menuList[i].menuId}`)
      if (htmlElement !== null) {
        htmlElement.setAttribute('class', '')
      }
    }
    // -------------------------Start------------------------------------------------ //
    // Storing Menu level 1 Details (Bottom Level)
    const menuLevel1Details = _.find(menuList, function currentMenuDetails(obj) {
      return obj.menuId === data
    })
    let menuLevel2Details = null
    let menuLevel3Details = null
    // Set Bottom level class as Active
    const htmlElement = document.getElementById(liID)
    if (htmlElement !== null) {
      htmlElement.setAttribute('class', 'active')
    }
    // -------------------------End------------------------------------------------ //

    // -------------------------Start------------------------------------------------ //
    // Storing Menu level 2 Details (Middle Level)
    if (menuLevel1Details !== null || typeof menuLevel1Details !== 'undefined') {
      menuLevel2Details = _.find(menuList, function findParentDetails(obj) {
        return obj.menuId === menuLevel1Details.ParentID
      })
      // -------------------------End------------------------------------------------ //

      // -------------------------Start------------------------------------------------ //
      // Storing Menu level 3 Details (Top Level)
      if (typeof menuLevel2Details !== 'undefined' || menuLevel2Details !== null) {
        menuLevel3Details = _.find(menuList, function findParentDetails(obj) {
          return obj.menuId === menuLevel2Details.ParentID
        })
      }
      // -------------------------End------------------------------------------------ //
      if (menuLevel3Details !== null && typeof menuLevel3Details !== 'undefined') {
        const menuLevel3LinkID = `Link${menuLevel3Details.menuId}`
        const menuLevel3ULID = `app${menuLevel3Details.menuId}`
        const htmlElementLevel3 = document.getElementById(menuLevel3LinkID)
        if (htmlElementLevel3 !== null) {
          htmlElementLevel3.setAttribute('aria-expanded', '')
          htmlElementLevel3.setAttribute('aria-expanded', 'true')
        }
        const htmlULElementevel3 = document.getElementById(menuLevel3ULID)
        if (htmlULElementevel3 !== null) {
          htmlULElementevel3.setAttribute('class', '')
          htmlULElementevel3.setAttribute('class', 'submenu list-unstyled ulnone collapse show')
        }
      }
      if (menuLevel2Details !== null && typeof menuLevel2Details !== 'undefined') {
        const menuLevel2ID = `Link${menuLevel2Details.menuId}`
        const menuLevel2ULID = `app${menuLevel2Details.menuId}`
        const htmlElementLevel2 = document.getElementById(menuLevel2ID)
        if (htmlElementLevel2 !== null) {
          htmlElementLevel2.setAttribute('aria-expanded', '')
          htmlElementLevel2.setAttribute('aria-expanded', 'true')
        }

        const htmlULElementevel2 = document.getElementById(menuLevel2ULID)
        if (htmlULElementevel2 !== null) {
          htmlULElementevel2.setAttribute('class', '')
          htmlULElementevel2.setAttribute('class', 'submenu list-unstyled ulnone collapse show')
          if (menuLevel3Details !== null && typeof menuLevel3Details !== 'undefined') {
            htmlULElementevel2.setAttribute(
              'class',
              'list-unstyled sub-submenu level-3 collapse show',
            )
          } else {
            htmlULElementevel2.setAttribute('class', 'submenu list-unstyled ulnone collapse show')
          }
        }
      }
    }
  }

  OnParentMenuClick = data => {
    for (let i = 0; i < menuList.length; i += 1) {
      const htmlElement = document.getElementById(menuList[i].menuId)
      if (htmlElement !== null) {
        htmlElement.setAttribute('data-active', 'false')
      }
    }

    for (let i = 0; i < menuList.length; i += 1) {
      const htmlElement = document.getElementById(`li_${menuList[i].menuId}`)
      if (htmlElement !== null) {
        htmlElement.setAttribute('class', '')
      }
    }
    for (let i = 0; i < menuList.length; i += 1) {
      const htmlElement = document.getElementById(`Link${menuList[i].menuId}`)
      if (htmlElement !== null) {
        htmlElement.setAttribute('aria-expanded', 'false')
      }
      const htmlULElement = document.getElementById(`app${menuList[i].menuId}`)
      if (htmlULElement !== null) {
        htmlULElement.setAttribute('class', '')
        htmlULElement.setAttribute('class', 'submenu list-unstyled ulnone collapse')
      }
    }
    const htmlElement = document.getElementById(data)
    if (htmlElement !== null) {
      htmlElement.setAttribute('data-active', 'true')
    }
  }

  getMenuHerirchy = tree => {
    menuContentArray = []
    for (let i = 0; i < tree.length; i += 1) {
      const rootMenuObj = tree[i]
      if (typeof rootMenuObj?.children !== 'undefined') {
        if (rootMenuObj.children.length > 0) {
          menuContentArray.push(
            <li className="menu" key={rootMenuObj.menuId}>
              <a
                href={`#app${rootMenuObj.menuId}`}
                data-toggle="collapse"
                aria-expanded="false"
                className="dropdown-toggle"
                id={`Link${rootMenuObj.menuId}`}
              >
                <div className="d-flex align-items-center">
                  <i className={rootMenuObj.iconClass} />
                  <span className="white-space-normal"> {i18n.t(rootMenuObj.menuName)}</span>
                </div>
                <span>
                  <i className="fa fa-angle-right" />
                </span>
              </a>
              <ul
                className="collapse submenu list-unstyled ulnone"
                id={`app${rootMenuObj.menuId}`}
                data-parent="#accordionExample"
              >
                {rootMenuObj.children.map(obj => {
                  let tempVar = ''
                  if (typeof obj?.children !== 'undefined') {
                    if (obj.children.length > 0) {
                      tempVar = (
                        <li key={obj.menuId}>
                          <a
                            href={`#app${obj.menuId}`}
                            data-toggle="collapse"
                            aria-expanded="false"
                            className="dropdown-toggle"
                            id={`Link${obj.menuId}`}
                          >
                            <div key={obj.menuId}>
                              <i className={obj.iconClass} />
                              <span> {i18n.t(obj.menuName)}</span>
                            </div>
                            <span>
                              <i className="fa fa-angle-right m-0 text-center" />
                            </span>
                          </a>
                          <ul
                            className="list-unstyled sub-submenu collapse level-3"
                            id={`app${obj.menuId}`}
                            data-parent={`#app${rootMenuObj.menuId}`}
                          >
                            {obj.children.map(objChild => {
                              return (
                                <li id={`li_${objChild.menuId}`} key={`li_${objChild.menuId}`}>
                                  <Link
                                    to={objChild.menuLink}
                                    id={objChild.menuId}
                                    onClick={() =>
                                      this.OnMenuClickWithRemoveTimeOut(objChild.menuId)
                                    }
                                  >
                                    <div key={objChild.menuId}>
                                      <i className={objChild.iconClass} />
                                      <span> {i18n.t(objChild.menuName)} </span>
                                    </div>
                                  </Link>
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                      )
                    }
                  } else {
                    tempVar = (
                      <li id={`li_${obj.menuId}`} key={`li_${obj.menuId}`}>
                        <Link
                          to={obj.menuLink}
                          id={obj.menuId}
                          onClick={() => this.OnMenuClickWithRemoveTimeOut(obj.menuId)}
                        >
                          <div key={obj.menuId}>
                            <i className={obj.iconClass} />
                            <span> {i18n.t(obj.menuName)} </span>
                          </div>
                        </Link>
                      </li>
                    )
                  }
                  return tempVar
                })}
              </ul>
            </li>,
          )
        }
      } else {
        menuContentArray.push(
          <MenuListComponent
            menuId={rootMenuObj.menuId}
            OnMenuLinkClick={this.OnParentMenuClick}
            menuLink={rootMenuObj.menuLink}
            iconClass={rootMenuObj.iconClass}
            menuName={i18n.t(rootMenuObj.menuName)}
            key={rootMenuObj.menuName}
          />,
        )
      }
    }
  }

  getListofMenu = (array, parent, tree) => {
    tree = typeof tree !== 'undefined' ? tree : []
    parent = typeof parent !== 'undefined' ? parent : { menuId: 0 }
    const children = _.filter(array, function childrenFilterfromParent(child) {
      return child.ParentID === parent.menuId
    })
    if (!_.isEmpty(children)) {
      if (parent.menuId === 0) {
        tree = children
      } else {
        parent.children = children
      }
      for (let k = 0; k < children.length; k += 1) {
        const child = children[k]
        this.getListofMenu(array, child)
      }
    }
    this.getMenuHerirchy(tree)
  }

  render() {
    menuList = this.props.menuList
    this.getListofMenu(menuList)
    const urlReferenceLink = window.location.pathname
    let menuIDforRefreshPage = _.find(menuList, function findMenu(obj) {
      return obj.menuLink === urlReferenceLink
    })

    if (menuIDforRefreshPage === dataConstant.Undefined && menuList.length > 0) {
      const subMenuReferenceLink =
        urlReferenceLink.split('/').length === 3 || urlReferenceLink.split('/').length === 2
          ? urlReferenceLink.split('/')[1]
          : ''
      var subMenuList = _.filter(menuList, menu => menu.subMenuLink !== null)
      var menuWithAllSubMenu = _.flatten(
        _.map(subMenuList, item => {
          const subMenuLinks = item.subMenuLink.split(',')
          return _.map(subMenuLinks, menu => {
            return { menuId: item.menuId, menuLink: item.menuLink, subMenuLink: menu }
          })
        }),
      )
      menuIDforRefreshPage = _.find(menuWithAllSubMenu, function findMenu(obj) {
        return obj.subMenuLink === `/${subMenuReferenceLink}`
      })
    }

    if (typeof menuIDforRefreshPage !== dataConstant.APIResponseStatus.Undefined) {
      if (menuIDforRefreshPage.ParentID === 0) {
        this.OnParentMenuClick(menuIDforRefreshPage.menuId)
      } else {
        this.OnMenuLinkClick(menuIDforRefreshPage.menuId)
      }
    }
    return (
      <>
        <div className="sidebar-wrapper sidebar-theme">
          <nav id="sidebar">
            <div className="shadow-bottom" />
            <ul className="list-unstyled menu-categories" id="accordionExample">
              {menuContentArray}
            </ul>
          </nav>
        </div>
      </>
    )
  }
}

export default withTranslation()(MenuLeft)
